import React from "react";
import '../styles/Footer.css';
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer id="contact" className="footer-section">

      <Container>
        <Row className="footer-top">
          <Col md={6} className="footer-about mb-4 mb-md-0">
            <h5 className="footer-title">PMJ Logistics Solutions </h5>
            <p className="footer-text">
              Your trusted partner in end-to-end logistics and supply chain solutions since 2019.
              <br /> Serving clients with precision and excellence.
            </p>
          </Col>

          <Col md={3} className="footer-links mb-4 mb-md-0">
            <h6 className="footer-subtitle">Quick Links</h6>
            <ul className="list-unstyled">
              <li><a href="#services">Services</a></li>
              <li><a href="#about-us">About Us</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
             
            </ul>
          </Col>

          <Col md={3} className="footer-contact">
            <h6 className="footer-subtitle">Contact</h6>
            <p>
              <span role="img" aria-label="location">📍</span> Pune, Maharashtra, India
            </p>
            <p>
              <span role="img" aria-label="telephone">📞</span> +91-8975756725/8668676828
            </p>
            <p className="email-line">
             <span role="img" aria-label="email">✉️</span>
            <a href="mailto:rakeshpatta@pmjlogisticssolutions.com"
            className="email-text">
            rakeshpatta@pmjlogisticssolutions.com
           </a>
          </p>

           <p className="email-line">
           <span role="img" aria-label="email">✉️</span>
          <a href="mailto:mukeshpatta@pmjlogisticssolutions.com"
          className="email-text">
          mukeshpatta@pmjlogisticssolutions.com
          </a>
         </p>

          </Col>
        </Row>

        <hr className="footer-divider" />

        {/* Bottom Lines */}
        <Row>
          <Col className="text-center">
            <p className="footer-tagline">Comprehensive Logistics & Supply Chain Services</p>
            <p className="footer-tagline">5+ Years of Trusted Operations</p>
            <p className="footer-copy">
              &copy; {new Date().getFullYear()} PMJ Logistics Solutions. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
